import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Globe2 } from "lucide-react";
import { api } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const ZONES = [
  ["America/New_York", "Eastern"], ["America/Chicago", "Central"], ["America/Denver", "Mountain"],
  ["America/Phoenix", "Arizona"], ["America/Los_Angeles", "Pacific"], ["America/Anchorage", "Alaska"],
  ["Pacific/Honolulu", "Hawaii"],
];

export const BusinessTimezoneCard = () => {
  const [tz, setTz] = useState(null);
  const [isDefault, setIsDefault] = useState(false);

  useEffect(() => {
    api.get("/business/timezone").then(({ data }) => { setTz(data.timezone); setIsDefault(data.is_default); }).catch(() => {});
  }, []);

  const [saving, setSaving] = useState(false);
  const change = async (value) => {
    const prev = tz;
    setTz(value); setSaving(true);
    try {
      await api.put("/business/timezone", { timezone: value });
      setIsDefault(false);
      toast.success("Business time zone saved");
    } catch (e) {
      setTz(prev);
      toast.error(e?.response?.data?.detail || "Could not save time zone");
    } finally {
      setSaving(false);
    }
  };

  const zones = tz && !ZONES.some(([z]) => z === tz) ? [[tz, tz], ...ZONES] : ZONES;
  return (
    <div className="bg-white border border-zinc-200 rounded-xl p-6 card-crisp mb-8" data-testid="business-timezone-card">
      <div className="flex items-center gap-2 mb-1">
        <Globe2 className="w-4 h-4 text-[#FF5A00]" />
        <h2 className="font-heading text-xl font-bold">Business time zone</h2>
      </div>
      <p className="text-sm text-zinc-500 mb-4">
        Decides which calendar day a payment counts on in revenue reports and the Payments dashboard.
        {isDefault && " Currently using the default (Central)."}
      </p>
      {tz && (
        <Select value={tz} onValueChange={change} disabled={saving}>
          <SelectTrigger className="max-w-xs" data-testid="business-timezone-select"><SelectValue /></SelectTrigger>
          <SelectContent>
            {zones.map(([z, label]) => (
              <SelectItem key={z} value={z} data-testid={`business-timezone-option-${z}`}>{label} — {z}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
    </div>
  );
};
